<template>
  <div id="TimerInfo">
    {{timerJSON}}
  </div>
</template>

<script>
// /#/GameBroadcastRaw?id=Test
export default {
  name: 'GameBroadcastRaw',
  data: function () {
    return {
      timerJSON: {}
    }
  },
  created: function () {
    this.timerJSON = {broadcastId: this.$route.query.id}
  }
}
</script>
